<template>
    <div class="checkoutform">
        <form @submit.prevent="$emit('order')" class="flex -justify-center -wrap">
            <div class="form--column">
                <h3>{{ $t('checkout.details') }}</h3>
                <label for="referentie">{{ $t('checkout.reference') }}</label>
                <input type="text" name="referentie" id="referentie" class="input" v-model="checkout.name" required />

                <label for="remarks">{{ $t('checkout.remarks') }}</label>
                <textarea id="remarks" class="input" v-model="checkout.remarks"></textarea>

                <template v-if="!loggedin">
                    <br />
                    <br />
                    <label for="naam">{{ $t('contact.name') }}</label>
                    <input type="text" name="naam" id="naam" class="input" autocomplete="name" v-model="checkout.client.name" required />
                    <label for="emailadres">{{ $t('contact.email') }}</label>
                    <input type="email" name="emailadres" id="emailadres" class="input" autocomplete="email" v-model="checkout.client.email" required />
                    <label for="telefoonnummer">{{ $t('contact.phone') }}</label>
                    <input type="tel" name="telefoonnummer" id="telefoonnummer" class="input" autocomplete="tel" v-model="checkout.client.phone" required />
                    <label for="organisatie">{{ $t('checkout.organization') }}</label>
                    <input type="text" name="organisatie" id="organisatie" class="input" autocomplete="organization" v-model="checkout.client.organization" required />
                    <label for="address">{{ $t('checkout.address') }}</label>
                    <GMapsAddress name="address" id="address" class="input" autocomplete="newvalue" :required-parts="['number']" v-model="checkout.client.address" required />
                </template>
                <div v-else>
                    <label>{{ $t('checkout.organization') }}</label>
                    <div class="size-4">{{ this.$store.state.Auth.user.name }}</div>
                </div>
            </div>
            <div class="form--column" v-if="loggedin">
                <h3>{{ $t('checkout.contact') }}</h3>
                <label for="naam">{{ $t('contact.name') }}</label>
                <input type="text" name="naam" id="naam" class="input" autocomplete="name" v-model="checkout.contact.name" />
                <label for="emailadres">{{ $t('contact.email') }}</label>
                <input type="email" name="emailadres" id="emailadres" class="input" autocomplete="email" v-model="checkout.contact.email" />
                <label for="telefoonnummer">{{ $t('contact.phone') }}</label>
                <input type="tel" name="telefoonnummer" id="telefoonnummer" class="input" autocomplete="tel" v-model="checkout.contact.phone" />
                <br />
            </div>
            <div class="form--column">
                <h3>{{ $t('checkout.delivery') }}</h3>
                <div v-if="ccs && ccs.cc" class="card delivery--estimate">
                    <div>
                        <span class="fa primary-lighter">&#xf466;</span>&nbsp;{{ $t('checkout.size_estimate') }}:
                    </div>
                    <div>
                        {{ $tc('checkout.ccs', ccs.cc) }} - {{ $tc('checkout.plates', ccs.plates) }}
                    </div>

                </div>
                <fieldset>
                    <label for="deliverytype">{{ $t('checkout.delivery_type') }}</label>
                    <div class="radio__group radio__group--horizontal">
                        <input type="radio" id="deliverytype_pickup" name="deliverytype" v-model="checkout.delivery.type" checked value="Ophalen" />
                        <label for="deliverytype_pickup">{{ $t('checkout.pickup') }}</label>
                        <input type="radio" id="deliverytype_delivery" name="deliverytype" v-model="checkout.delivery.type" value="Bezorging" />
                        <label for="deliverytype_delivery">{{ $t('checkout.deliver') }}</label>
                    </div>
                </fieldset>
                <fieldset v-if="checkout.delivery.type === 'Bezorging'">
                    <label for="delivery_address">{{ $t('checkout.delivery_address') }}</label>
                    <template v-if="!change_address && checkout.client.address_string">
                        <div class="-group-input">
                            <input readonly class="input" id="delivery_address" :value="checkout.client.address_string" />
                            <button type="button" @click="change_address = !change_address">{{ $t('checkout.delivery_address_change') }}</button>
                        </div>
                    </template>
                    <GMapsAddress v-else name="delivery_address" id="delivery_address" class="input" autocomplete="newvalue" :required-parts="['number']" v-model="checkout.delivery.address" required />
                </fieldset>
                <fieldset>
                    <label for="delivery_date">{{ $t('checkout.delivery_date') }}</label>
                    <Datevuewer :min="'today'" v-model="checkout.delivery.date" />
                </fieldset>
                <fieldset v-if="user.delivery">
                    <label>{{ $t('checkout.delivery_conditions')}}</label>
                    <div v-html="user.delivery"></div>
                </fieldset>
            </div>
            <div class="-flex-stretch">
            </div>
            <button type="submit" :class="{ 'button_loading': loading }" :disabled="loading">
                <template v-if="loggedin">{{ $t('products.order_place') }}</template>
                <template v-else>{{ $t('products.request_quote') }}</template>
            </button>
        </form>
    </div>
</template>

<script>
import Datevuewer from '@bit/duncank.work.datevuewer';

export default {
    name: 'CheckoutForm',
    components: { Datevuewer },
    props: {
        ccs: Object,
        loading: Boolean,
    },
    computed: {
        loggedin() {
            return this.$store.getters['Auth/isAuthenticated'];
        },

        checkout() {
            return this.$store.getters['Products/checkout'];
        },

        user() {
            return this.$store.getters['Auth/user'];
        },
    },
    data() {
        return {
            change_address: false,
            mode: 'details',
        };
    },
};
</script>
<style>
:root {
    --card-bg: #fff;
    --color-bg: var(--color-bg-darker);
    --color-secondary: var(--color-primary-light);
    --color-danger: var(--color-danger);
    --color-border: #d1d1d1;
}
    .datevuewer .-wrapper { display: contents; }
    .datevuewer .mdi-chevron-right::before {
        content: '>';
    }
    .datevuewer .mdi-chevron-left::before {
        content: '<';
    }
    .delivery--estimate { margin-bottom: 1.6rem; }
</style>
